import { useQuery } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import api from 'api/api';
import useVersionInfo from 'hooks/useVersionInfo';
import { isV4Release } from 'utilities/constants/versions';

import { FetchDatasetParams } from '../types';

import { DocumentationResponse } from './types';

const fetchDatasetDocumentation = async (params: FetchDatasetParams) => {
  const { data } = await api.get(`/spold/documentation`, { params });

  return data;
};

/** The mirror of useV4DatasetDocumentation: the 3.x endpoint has no data for a v4 release. */
const useDatasetDocumentation = (id?: string) => {
  const { ver: version, system_model } = useVersionInfo();
  return useQuery<DocumentationResponse, AxiosError>({
    queryKey: ['documentation', id, version, system_model],
    queryFn: () => fetchDatasetDocumentation({ dataset_id: id as string, version, system_model }),
    enabled: !isV4Release(version) && !!id,
    retry: false,
  });
};

export default useDatasetDocumentation;
